import { render, staticRenderFns } from "./contractSettings.vue?vue&type=template&id=10b13d70&scoped=true"
import script from "./contractSettings.vue?vue&type=script&lang=js"
export * from "./contractSettings.vue?vue&type=script&lang=js"
import style0 from "./contractSettings.vue?vue&type=style&index=0&id=10b13d70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b13d70",
  null
  
)

export default component.exports